import React from "react";
import useUser from "../../../../hooks/super/useUser";
import { ConfirmModal } from "../../../../components/pages/_new/super/design";

function DisableUserModal({ open, handleClose, uid, userName }) {
  const { disableUser } = useUser();
  const [busy, setBusy] = React.useState(false);

  const list = Array.isArray(userName) ? userName : [];
  const plural = list.length > 1 ? "s" : "";

  const onConfirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await disableUser(uid);
      handleClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      open={open}
      onClose={handleClose}
      onConfirm={onConfirm}
      variant="warning"
      title={`Disable user${plural}?`}
      body={`The selected user${plural} will be prevented from signing in until re-enabled.`}
      items={list.map((u) => ({ id: u.id, title: u.email }))}
      submitLabel="Disable"
      loading={busy}
    />
  );
}

export default DisableUserModal;
